module.exports = __webpack_public_path__ + "static/media/paypal.7c552892.svg";